import { twMerge } from "tailwind-merge";

export function withClassName<T extends object>(fn: (data: T) => string, className?: string) {
  return className
    ? (props: T) => twMerge(fn(props), className)
    : (props?: T & { className?: string }) => twMerge(fn(props as T), props?.className);
}
